// The @bloqtalk service account is the official BLOQ Talk account. Its messages/links are
// treated as pre-verified and it is pinned to the top of chat lists.
export const OFFICIAL_HANDLE = "bloqtalk";

export function isOfficialUser(u) {
  if (!u) return false;
  return u.username === OFFICIAL_HANDLE || u.handle === OFFICIAL_HANDLE;
}
